import styled from 'styled-components';

import { PULSE, ANIM, ACQ_MOBILE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** "Players by value" allocation — a tinted panel (NO border) holding the label,
 *  the stacked share bar and the legend (Figma: bg rgba(45,45,51,0.33), 16px radius). */
export const Allocation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${PULSE.panel};
  border-radius: 16px;
  padding: 12px;
`;

export const SubLabel = styled(Text)`
  display: block;
  font-size: 16px;
  color: ${PULSE.t300};
`;

/** Players-by-value stacked bar — segments grow to their share on mount, on a
 *  50%-white track, divided by 1px black hairlines. */
export const SegBar = styled.div`
  display: flex;
  height: 8px;
  border-radius: 100px;
  overflow: hidden;
  background: ${PULSE.segTrack};
`;

export const Seg = styled.span<{ $color: string; $width: number }>`
  display: block;
  width: ${(p) => p.$width}%;
  background: ${(p) => p.$color};
  border-right: 1px solid #000;
  transition: width ${ANIM.PULSE_BAR_ENTER_MS}ms ${PULSE.ease};
`;

export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 3px;
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  color: ${PULSE.t300};
`;

export const Dot = styled.i<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(p) => p.$color};
`;

export const ReachStats = styled.div<{ $count: number }>`
  display: grid;
  /* Column count tracks the number of visible stats, so hiding an in-progress stat
   * (e.g. 30-day Retention) collapses the row instead of leaving an empty column. */
  grid-template-columns: repeat(${(p) => Math.max(1, p.$count)}, 1fr);
  gap: 10px;

  ${ACQ_MOBILE} {
    grid-template-columns: 1fr;
  }
`;

/** Reach-stat panel — tinted, NO border (Figma). */
export const ReachStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: ${PULSE.panel};
  border-radius: 16px;
  padding: 12px;
`;

export const RsLabel = styled(Text)`
  display: block;
  font-size: 16px;
  color: ${PULSE.t300};
`;

export const RsValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${PULSE.t50};
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const RsNote = styled(Text)`
  font-size: 13px;
  font-weight: 400;
  letter-spacing: -0.0762px;
  color: ${PULSE.t600};
`;

/** Muted placeholder shown where a missing data point would sit — the player-value
 *  share bar (the stats API exposes no VIP / Regular / Casual / New tiering). */
export const NotAvailable = styled(Text)`
  display: block;
  font-size: 14px;
  color: ${PULSE.t500};
`;
